import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class DatabasePutService {
     
    serviceBase = environment.API_URL + '/api/database';
    queryString: string;

    constructor(private http: HttpClient) { }      

    approveRejectCountryList(id: any, approveRejectData, tableName: string) {
        switch (tableName) {
            case 'Country List':
                this.queryString = '/approveOrRejectCountry?id=' + id;
                break;
            case 'City List':
                this.queryString = '/approveOrRejectCity?id=' + id;
                break;
            case 'City Utility Cost':
                this.queryString = '/approveOrRejectCityUtilityCost?id=' + id;
                break;
            case 'City Basecase LPD':
                this.queryString = '/approveOrRejectCityLpd?id=' + id;
                break;
            case 'City Basecase Materials':
                this.queryString = '/approveOrRejectCityBaseCaseMaterial?id=' + id;
                break;
            case 'City Basecase Material Thickness':
                this.queryString = '/approveOrRejectCityMaterialThickness?id=' + id;
                break;
            case 'City Water Fixture Base Case Flow':
                this.queryString = '/approveOrRejectCityWaterFixtureBaseCaseFlow?id=' + id;
                break;
            case 'City BaseCase WallUValue':
                this.queryString = '/approveOrRejectCityBaseCaseWallUValue?id=' + id;
                break;
            case 'City BaseCase RoofUValue':
                this.queryString = '/approveOrRejectCityBaseCaseRoofUValue?id=' + id;
                break;
            case 'City BaseCase GlassUValue':
                this.queryString = '/approveOrRejectCityBaseCaseGlassUValue?id=' + id;
                break;
            case 'City BaseCase SHGCValue':
                this.queryString = '/approveOrRejectCityBaseCaseSHGCValue?id=' + id;
                break;
        }       
        return this.http.put<any>(this.serviceBase + this.queryString, approveRejectData);
    }  
}
